import { DataLayerItem } from '../../StoreDetails/types'

export const buildDataLayerStoreSearch = (
  displayName: string
): DataLayerItem[] => {
  if (!displayName) {
    return []
  }
  return [
    { key: 'event', value: 'search' },
    { key: 'searchType', value: 'Suggested' },
    { key: 'searchQuery', value: displayName ?? '' }
  ]
}

export const buildDataLayerFilterClick = ({
  groupName,
  filterCode,
  filterLabel
}: {
  groupName?: string
  filterCode?: string
  filterLabel?: string
}): DataLayerItem[] => {
  return [
    { key: 'event', value: 'storeLocatorFilter' },
    { key: 'storeLocatorFilterCategory', value: groupName ?? '' },
    { key: 'storeLocatorFilterFilterID', value: filterCode ?? '' },
    { key: 'storeLocatorFilterName', value: filterLabel ?? '' }
  ]
}
